<app-paco-dialog [title]="'dataManagement.dataExchangeRequests.reopenDecisionDialog.title' | transloco" [actions]="dialogActions()" (actionTriggered)="onDialogAction($event)">
  <p class="intro">{{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.intro' | transloco }}</p>

  <div class="decision-toolbar">
    <button mat-stroked-button type="button" [disabled]="isSaving() || allIds().length === 0" (click)="decideAll('accept')">
      <mat-icon>check</mat-icon>
      {{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.acceptAll' | transloco }}
    </button>
    <button mat-stroked-button type="button" [disabled]="isSaving() || allIds().length === 0" (click)="decideAll('reject')">
      <mat-icon>close</mat-icon>
      {{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.rejectAll' | transloco }}
    </button>
  </div>

  <div class="reopen-table-wrapper">
    <table mat-table [dataSource]="dataSource" class="full-width plain-table">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>{{ 'commonPackagingFields.id' | transloco }}</th>
        <td mat-cell *matCellDef="let sub">{{ sub.id }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.name' | transloco }}</th>
        <td mat-cell *matCellDef="let sub">{{ getName(sub) }}</td>
      </ng-container>

      <ng-container matColumnDef="articleNumber">
        <th mat-header-cell *matHeaderCellDef>{{ 'component.fields.articleNumber' | transloco }}</th>
        <td mat-cell *matCellDef="let sub">{{ getArticleNumber(sub) }}</td>
      </ng-container>

      <ng-container matColumnDef="requestedAt">
        <th mat-header-cell *matHeaderCellDef>{{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.requestedOn' | transloco }}</th>
        <td mat-cell *matCellDef="let sub">{{ getDate(sub.reopenRequestedAt) | date: 'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef>{{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.comment' | transloco }}</th>
        <td mat-cell *matCellDef="let sub" class="comment-cell">{{ getLatestComment(sub)?.comment }}</td>
      </ng-container>

      <ng-container matColumnDef="decision">
        <th mat-header-cell *matHeaderCellDef class="decision-cell"></th>
        <td mat-cell *matCellDef="let sub" class="decision-cell">
          <button
            mat-icon-button
            type="button"
            class="decision-button decision-button--accept"
            [class.decision-button--active]="getDecision(sub.id) === 'accept'"
            [disabled]="isSaving()"
            [title]="'dataManagement.dataExchangeRequests.reopenDecisionDialog.accept' | transloco"
            (click)="decide(sub.id, 'accept')">
            <mat-icon>check</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            class="decision-button decision-button--reject"
            [class.decision-button--active]="getDecision(sub.id) === 'reject'"
            [disabled]="isSaving()"
            [title]="'dataManagement.dataExchangeRequests.reopenDecisionDialog.reject' | transloco"
            (click)="decide(sub.id, 'reject')">
            <mat-icon>close</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          {{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.noPending' | transloco }}
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator class="paginator" [length]="totalCount()" [pageIndex]="pageIndex()" [pageSize]="pageSize()" [pageSizeOptions]="pageSizeOptions" (page)="onPageChanged($event)">
  </mat-paginator>

  <p class="decision-summary">
    {{
      'dataManagement.dataExchangeRequests.reopenDecisionDialog.summary'
        | transloco: { accepted: acceptedIds().length, rejected: rejectedIds().length, undecided: undecidedCount() }
    }}
  </p>

  <div class="deadline-row">
    <mat-form-field appearance="outline" class="deadline-field">
      <mat-label>{{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.deadlineLabel' | transloco }}</mat-label>

      <input matInput [matDatepicker]="deadlinePicker" [formControl]="deadlineControl" />

      <mat-datepicker-toggle matSuffix [for]="deadlinePicker" />

      <mat-datepicker #deadlinePicker />

      @if (acceptedIds().length === 0) {
        <mat-hint>{{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.deadlineDisabledHint' | transloco }}</mat-hint>
      } @else if (isDeadlineInPast()) {
        <mat-hint class="past-warning">{{ 'dataManagement.dataExchangeRequests.reopenDecisionDialog.pastWarning' | transloco }}</mat-hint>
      }
    </mat-form-field>

    @if (deadlineControl.value && acceptedIds().length > 0) {
      <button mat-button class="clear-button" type="button" (click)="clearDeadline()">
        {{ 'dataManagement.dataExchangeRequests.editDeadlineDialog.clearAction' | transloco }}
        <mat-icon class="clear-icon">close</mat-icon>
      </button>
    }
  </div>

  @if (errorMessageKey()) {
    <p class="dialog-error">{{ errorMessageKey() | transloco }}</p>
  }
</app-paco-dialog>
